import { render } from "./PolicyDetailPage.vue?vue&type=template&id=58e160e2"
import script from "./PolicyDetailPage.vue?vue&type=script&lang=js"
export * from "./PolicyDetailPage.vue?vue&type=script&lang=js"

import "@/assets/scss/hezabat.scss?vue&type=style&index=0&lang=scss"
import "@/assets/scss/policy-detail.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__